<template>
  <div class="yhc-component YhcInput" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>
    <div class="content">
      <el-input
        class="el-component-item"
        @input="change"
        v-model="result"
        :clearable="clearable"
        :disabled="onlyRead"
        :type="type"
        :placeholder="placeholder ? placeholder : `请输入${label}`"
      ></el-input>
    </div>
    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import watchMixin from './componentsData/watchMixin';
import mountedMixin from './componentsData/mountedMixin';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

import onlyMoneyInput from 'evenlea-utils/regular/onlyMoneyInput';

import extractLetterAndDigital from 'evenlea-utils/regular/extractLetterAndDigital';

let identifierName = 'YhcInput';

export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin, watchMixin, mountedMixin],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    value: {
      type: [String, Boolean, Number],
    },
    type: {
      type: String,
      default: 'text',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    onlyReadShowData: {
      type: [Number, String],
    },
    isMoneyData: {
      type: Boolean,
      default: false,
    },
    isIntData: {
      type: Boolean,
      default: false,
    },
    isNegativeData: {
      type: Boolean,
      default: false,
    },
    isLetterAndDigital: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  watch: {},
  methods: {
    change() {
      if (this.isMoneyData) {
        this.result = onlyMoneyInput(this.result);
      }
      if (this.isIntData) {
        this.result = Math.floor(onlyMoneyInput(this.result));
      }
      if (this.isNegativeData) {
        this.result = Math.abs(Math.floor(onlyMoneyInput(this.result)));
      }
      if (this.isLetterAndDigital) {
        this.result = extractLetterAndDigital(this.result);
      }
      this.$emit('change', this.result, this.index);
      this.$emit('input', this.result, this.index);
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcInput {
  @include labelCommon();
}
</style>
